import styled from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export default ContentWrapper;



// WEBPACK FOOTER //
// ./components/AppBody/ContentWrapper.js